module.exports = __webpack_public_path__ + "img/metalmanufacturing_icon.84c13598.svg";